export default {
    namespaced: true,
    state: {
        isShowIp:false,
        imageCol:[]
    },
    mutations: {
        setIp(state, data) {
            state.isShowIp = data
        },
        setImageCol(state, data) {
            state.imageCol = data
        }
    },
};